<template>
  <div class="part2">
    <img
      class="img1"
      src="https://summit-img.geekpark.net/if2021/pc/02-主题诠释-pc.png"
    />
    <img
      class="img2"
      src="https://summit-img.geekpark.net/if2021/pc/02-GLANCE-pc.svg"
    />
    <div class="desc-video-wrapper">
      <div class="cover" @click="playVideo" v-show="!videoStarted">
        <img
          src="https://summit-img.geekpark.net/if2021/pc/02-播放按钮-通用.svg"
          alt=""
        />
      </div>
      <video
        style="width: 100%; height: 100%;"
        ref="video"
        poster="https://summit-img.geekpark.net/if2021/视频封面.jpg"
        controlslist="nodownload noremoteplayback"
        :controls="videoStarted"
      >
        <source
          type="video/mp4"
          src="https://summit-img.geekpark.net/if2021/video/if2021%E5%AE%A3%E4%BC%A0HD.mp4"
        />
      </video>
    </div>
  </div>
</template>

<script>
export default {
  name: "Part2",
  data() {
    return {
      videoStarted: false,
      isPlaying: false,
    };
  },
  mounted() {
    const video = this.$refs.video;
    video.disablePictureInPicture = true;
    video.addEventListener(
      "pause",
      () => {
        this.isPlaying = false;
      },
      false
    );
    video.addEventListener(
      "play",
      () => {
        this.isPlaying = true;
      },
      false
    );
  },
  methods: {
    playVideo() {
      this.$refs.video.play();
      this.videoStarted = true;
      this.isPlaying = true;
    },
  },
};
</script>

<style lang="less" scoped>
.part2 {
  position: relative;
  .img1 {
    height: 96vh;
    width: auto;
  }
  .img2 {
    height: 24vh;
    width: auto;
    position: absolute;
    right: -4vh;
    bottom: -3vh;
    z-index: -2;
  }
  .desc-video-wrapper {
    height: 66vh;
    width: 122vh;
    position: absolute;
    top: 16.1vh;
    right: 15.5vh;
    overflow: hidden;
    &:hover {
      cursor: pointer;
    }
    .cover {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 10;

      img {
        width: 12vh;
        height: 12vh;
      }
    }
    video:focus {
      border: none;
      outline: none;
    }
  }
}
</style>